<template>
  <div>
    <vf-media-gallery-pagination v-if="!mediaGalleryHorizontalScroll?.enabled" v-bind="forwarded" />
    <div v-else>
      <div class="absolute inset-x-0 bottom-0 z-1 flex duration lg:hidden" data-test-id="vf-media-gallery-pagination">
        <div
          v-for="(_, key) in pages"
          :key
          class="grow duration"
          :class="activePage === key ? 'bg-brand-4' : 'bg-transparent'"
          style="height: 0.125rem"
        />
      </div>
      <vf-carousel-pagination-dots
        v-if="pages"
        :active="activePage"
        class="absolute inset-x-0 bottom-0 mx-6 mb-1.75 shrink-0 <lg:hidden"
        data-test-id="vf-media-gallery-pagination"
        show-all-dots
        :total="pages"
        @update:active="$emit('navigate', $event)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Props } from '#brand/components/vf/media-gallery/Pagination.vue'
import VfMediaGalleryPagination from '#brand/components/vf/media-gallery/Pagination.vue'

const props = defineProps<Props>()
defineEmits<{
  navigate: [index: number]
}>()
const mediaGalleryHorizontalScroll = useOptimizelyFlag('media_gallery_horizontal_scroll')

const forwarded = useForwardProps(props)
</script>
